import React from 'react'

const Manage_billing = () => {
  return (
    <div>Manage_billing</div>
  )
}

export default Manage_billing